import React from 'react';

const colors = require('common/lib/colors/colors.less');
import { Board } from './Board';
import CardLabel from './CardLabel';

const PlaceholderBoard = Board.extend`
  height: 96px;
  padding: 16px;
`;

const TopBar = CardLabel.extend`
  display: block;
  margin-bottom: 8px;
  width: 112px;
`;

const BottomBar = CardLabel.extend`
  display: block;
  width: 32px;
`;

const PlaceholderCard = ({ className = '' }) => (
  <PlaceholderBoard bgColor={colors.N40A}>
    <TopBar color="N30" />
    <BottomBar color="N30" />
  </PlaceholderBoard>
);

export default PlaceholderCard;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/PlaceholderCard.js